import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PURGE } from 'redux-persist'
import { BiometricLoginStatus, ConsumerCredential } from '../../model'
import { finishBiometricAuthentication, startBiometricAuthentication, getConsumerCredentials } from './actions'

export interface BiometricState {
  allowDisplayingModal: boolean
  loginStatus: BiometricLoginStatus
  credentials: ConsumerCredential[]
  hasSilentErrors: boolean
  isBiometricEnabledOnServer?: boolean
}

export const biometricInitialState: BiometricState = {
  allowDisplayingModal: true,
  loginStatus: BiometricLoginStatus.NotStarted,
  credentials: [],
  hasSilentErrors: false,
}

const biometricSlice = createSlice({
  name: 'biometric',
  initialState: biometricInitialState,
  reducers: {
    setAllowDisplayingModal(state: BiometricState, action: PayloadAction<boolean>): BiometricState {
      return {
        ...state,
        allowDisplayingModal: action.payload,
      }
    },
    setBiometricLoginStatus(state: BiometricState, action: PayloadAction<BiometricLoginStatus>): BiometricState {
      return {
        ...state,
        loginStatus: action.payload,
      }
    },
    setHasSilentBiometricErrors(state: BiometricState, action: PayloadAction<boolean>): BiometricState {
      return {
        ...state,
        hasSilentErrors: action.payload,
      }
    },
    setIsBiometricEnabledOnServer(state: BiometricState, action: PayloadAction<boolean>): BiometricState {
      return {
        ...state,
        isBiometricEnabledOnServer: action.payload,
      }
    },
  },
  extraReducers(builder) {
    builder
      .addCase(startBiometricAuthentication.rejected, (state, action) => {
        state.loginStatus = BiometricLoginStatus.Error
      })
      .addCase(finishBiometricAuthentication.rejected, (state, action) => {
        state.loginStatus = BiometricLoginStatus.Error
      })
      .addCase(finishBiometricAuthentication.fulfilled, (state, action) => {
        state.loginStatus = BiometricLoginStatus.Finished
        state.allowDisplayingModal = false
      })
      .addCase(getConsumerCredentials.fulfilled, (state, action) => {
        state.credentials = action.payload
      })
      .addCase(PURGE, () => biometricInitialState)
  },
})

export const { setAllowDisplayingModal, setBiometricLoginStatus, setHasSilentBiometricErrors, setIsBiometricEnabledOnServer } = biometricSlice.actions

export default biometricSlice.reducer
